export default __webpack_public_path__ + "locales/uk-UA/DowngradePlanDialog.json?hash=9528a3a5267a404578ff9812e1593ec3";